module.exports = __webpack_public_path__ + "static/media/cursor.2e6e8879.svg";